import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MerchantService } from '../../services/merchant/merchant.service';
import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';
import { ModalService } from '../../../../core/services/modal/modal.service';

@Component({
  selector: 'app-merchant-setting-stock',
  templateUrl: './merchant-setting-stock.component.html',
  styleUrl: './merchant-setting-stock.component.css'
})
export class MerchantSettingStockComponent implements OnInit {

  faScrewdriverWrench = faScrewdriverWrench

  form: FormGroup;
  formChanged = false
  shopDetials: any = {}
  shopId: string = this.authService.selectedShop?.shop_id || '';
  loading = false

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private merchantService: MerchantService,
    private modalService: ModalService
  ) {
    this.form = this.fb.group({
      minStock: [{ value: 0, }],
    });
  }

  ngOnInit(): void {
    this.loadShopDetails();
    this.form.valueChanges.subscribe(() => {
      this.formChanged = true;
    });
  }

  loadShopDetails() {
    this.loading = true;
    this.merchantService.getOneShop(this.shopId).then(response => {
      setTimeout(() => {
        this.loading = false;
      }, 100);
      if (response.success) {
        this.shopDetials = response.data
        const shopDetials = this.shopDetials
        this.form.patchValue({
          minStock: shopDetials?.min_stock || 0,
        });
        this.formChanged = false
      } else {
        console.log('load shop failed')
      }
    })
  }

  onSubmit() {
    if (!this.form.valid) return
    const data = this.form.getRawValue()
    console.log(data);
    let updateData: any = {
      min_stock: data.minStock,
    }
    console.log(updateData)
    this.merchantService.updateshop(this.shopId, updateData).then(response => {
      this.formChanged = false;
      if (response.success) {
        this.loadShopDetails()
        this.modalService.openModal('success', 'อัพเดตข้อมูลสำเร็จ', '').then(ok => {
          console.log('ok')
        })
      } else {
        console.log('failed')
        this.modalService.openModal('success', 'เกิดข้อผิดพลาด', 'กรุณาลองใหม่อีกครั้ง')
      }
    })
  }

  onCancel() {
    this.loadShopDetails()
  }

}
